import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import type { ICSSInJSStyle } from '@fluentui/styles';
import {
    PADDING_LEFT_RIGHT_SECTION,
    PADDING_TOP_CAPTION_MOBILE,
} from '../pagebuilder.style';

/**
 * Project detail revamp (BC-4725): the desktop caption text style every page
 * builder module shares — the Figma spec (Neue Haas Grotesk Text, white,
 * 0.86844rem / 130% / -0.02606rem) in a 25rem block, 2rem below the image.
 * The legacy 125px caption bottom margin is zeroed so the gallery grid's
 * 3.12rem gap is the whole inter-module space. Applied to the `ui-caption`
 * element from each module's caption container rule.
 */
export const PROJECT_REVAMP_CAPTION_TEXT: ICSSInJSStyle = {
    width: '25rem',
    maxWidth: '100%',
    marginTop: '2rem',
    marginBottom: 0,
    color: '#fff',
    fontFamily: 'neue-haas-grotesk-text',
    fontSize: '0.86844rem',
    fontWeight: 400,
    lineHeight: '130%',
    letterSpacing: '-0.02606rem',
};

export const TagMainCaptionContainer: StyleRule = ({ theme }) => ({
    '& > div': {
        marginTop: pxToRem(PADDING_TOP_CAPTION_MOBILE),
        width: '100%',
        fontSize: pxToRem(12),
        lineHeight: '125%',
    },

    [theme.screen.laptop]: {
        '& > div': {
            marginTop: pxToRem(48),
            paddingLeft: pxToRem(PADDING_LEFT_RIGHT_SECTION),
            width: '100%',
            fontSize: pxToRem(22),
            lineHeight: '120%',
            overflowWrap: 'break-word',
            fontWeight: 450,
            color: '#161616',
        },
    },
});

export const TagSubCaptionContainer: StyleRule<{
    moduleType?: string;
    isProject?: boolean;
    inViewPort?: boolean;
}> = ({ theme, moduleType, isProject }) => ({
    '& > div': {
        marginTop: pxToRem(PADDING_TOP_CAPTION_MOBILE),
        width: '100%',
        fontSize: pxToRem(12),
        lineHeight: '125%',
    },

    [theme.screen.laptop]: {
        '& > div': {
            marginTop: pxToRem(48),
            marginBottom: pxToRem(125),
            width: '100%',
            fontSize: pxToRem(22),
            lineHeight: '120%',
            color: 'black',
            textAlign: 'left',
            overflowWrap: 'break-word',
            fontWeight: 450,

            ...((moduleType === 'SingleImageModule' ||
                moduleType === 'FullPageGalleryModule') &&
                isProject && {
                    marginTop: pxToRem(48),
                }),
        },
    },
});
